import { ThemeProvider } from '@mui/material/styles';
import { theme as designSystemTheme } from '@openx/design-system/theme/theme.ts';
import type { ReactNode } from 'react';

export const OpenXAgentDesignSystemTheme = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={designSystemTheme}>{children}</ThemeProvider>
);
